import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeckglMapboxComponent } from './deckgl-mapbox/deckgl-mapbox.component'
import { Mobile2cadComponent } from './mobile2cad/mobile2cad.component';
import { DotappComponent } from './dotapp/dotapp.component';
import { DottestComponent } from './dottest/dottest.component';
import { Npr3ddemoComponent } from './npr3ddemo/npr3ddemo.component';

const routes: Routes = [

  { path: '', redirectTo: 'showcase-app', pathMatch: 'full' },
  { path: 'showcase-app', component: DeckglMapboxComponent, pathMatch: 'full' },
  { path: 'dotapp', component: DotappComponent, pathMatch: 'full' },
  { path: 'npr3d', component: DottestComponent, pathMatch: 'full' },
  { path: 'npr3ddemo', component: Npr3ddemoComponent, pathMatch: 'full' },
  { path: 'mobile2cad', component: Mobile2cadComponent, pathMatch: 'full' },
  { path: '**', component: DeckglMapboxComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
